import { SlimAlertVariants } from '../SlimAlert/SlimAlertVariants';
import {
  AnnouncementBannerContainer,
  AlertBannerContainer,
  MegaphoneIcon,
  TitleWrapper,
  AnnouncementCta,
  AlertCta,
  SpecialAlertIcon,
} from './AnnouncementBanner.styles';

interface AnnouncementBannerProps {
  title: string;
  cta: string;
  ctaLink?: string;
}

export const AnnouncementBanner = ({ title, cta, ctaLink }: AnnouncementBannerProps) => (
  <AnnouncementBannerContainer id="info-bar">
    <MegaphoneIcon />
    <TitleWrapper>
      {title} {cta && <AnnouncementCta href={ctaLink ?? '#'}>{cta}</AnnouncementCta>}
    </TitleWrapper>
  </AnnouncementBannerContainer>
);

export const WarningBanner = ({ title, cta, ctaLink }: AnnouncementBannerProps) => (
  <AlertBannerContainer id="info-bar">
    <SpecialAlertIcon
      as={SlimAlertVariants.Warning.Icon}
      $colorKey={SlimAlertVariants.Warning.primary}
    />
    <TitleWrapper>
      {title} {cta && <AlertCta href={ctaLink ?? '#'}>{cta}</AlertCta>}
    </TitleWrapper>
  </AlertBannerContainer>
);
